'use client'

import { useEffect, useMemo, useState } from 'react'
import { useCart } from './useCart'
import { isBookloActive } from '@/utils/order'

export type DeliveryType = 'delivery' | 'pickup'

type ValidationResult = { ok: true } | { ok: false; error: string }

export function useDelivery({ vendor, branches }: { vendor: any; branches: any[] }) {
  const { cart } = useCart()
  const products = cart?.products || []
  const [selectedDelivery, setSelectedDelivery] = useState<DeliveryType | null>(null)
  const [selectedBranch, setSelectedBranch] = useState<any>(null)

  const hasDeliveryProvider = isBookloActive(vendor?.deliveryProvider)

  useEffect(() => {
    if (!selectedDelivery) {
      if (vendor?.deliveryType === 'noDelivery' && !hasDeliveryProvider) setSelectedDelivery('pickup')
      else setSelectedDelivery('delivery')
    }
  }, [vendor, selectedDelivery, hasDeliveryProvider])

  useEffect(() => {
    if (branches && branches.length > 0 && !selectedBranch) {
      const defaultBranch = branches.find((branch: any) => branch.isDefault)
      setSelectedBranch(defaultBranch ? defaultBranch.id : branches[0].id)
    }
  }, [branches, selectedBranch])

  const selectDelivery = (delivery: DeliveryType) => setSelectedDelivery(delivery)

  const validateDelivery = (): ValidationResult => {
    if (!selectedDelivery) return { ok: false, error: 'Хүргэлтийн төрлийг сонгоно уу' }
    if (selectedDelivery === 'pickup' && !selectedBranch) return { ok: false, error: 'Салбараа сонгоно уу' }
    return { ok: true }
  }

  const allProductsDigital = products.length > 0 && products.every((p: any) => p.isDigital === true)
  const hasDigitalProduct = products.some((p: any) => p.isDigital === true)
  const hasDeliveryOption = !allProductsDigital && (hasDeliveryProvider || vendor?.deliveryType !== 'noDelivery')
  const hasPickupOption = !allProductsDigital && vendor?.canPickup && branches?.length > 0
  const showDeliverySection = hasDeliveryOption || hasPickupOption

  return useMemo(() => ({
    selectedDelivery,
    selectedBranch, setSelectedBranch,
    selectDelivery,
    validateDelivery,
    allProductsDigital,
    hasDigitalProduct,
    hasDeliveryOption,
    hasPickupOption,
    showDeliverySection,
  }), [selectedDelivery, selectedBranch, allProductsDigital, hasDigitalProduct, hasDeliveryOption, hasPickupOption, showDeliverySection])
}
